(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    

(function () {
  function initFAQ() {
    const faqSection = document.getElementById('faqsection');

    if (!faqSection) return;

    const triggers = faqSection.querySelectorAll(
      '.collapsible-trigger'
    );

    if (!triggers.length) return;

    /*
     * Initial state
     */
    triggers.forEach(function (trigger) {
      const contentId = trigger.getAttribute('aria-controls');
      const content = document.getElementById(contentId);

      if (!content) return;

      const isOpen = trigger.classList.contains('is-open');

      trigger.setAttribute(
        'aria-expanded',
        isOpen ? 'true' : 'false'
      );

      content.classList.toggle('is-open', isOpen);

      if (isOpen) {
        content.style.height = 'auto';
      } else {
        content.style.height = '0px';
      }
    });
  }


  /*
   * FAQ CLICK HANDLER
   *
   * Capture phase is intentional.
   * It prevents the theme's own collapsible JS
   * from fighting with this FAQ.
   */
  document.addEventListener(
    'click',
    function (event) {

      const trigger = event.target.closest(
        '#faqsection .collapsible-trigger'
      );

      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const contentId =
        trigger.getAttribute('aria-controls');

      const content =
        document.getElementById(contentId);

      if (!content) return;

      const isOpen =
        trigger.getAttribute('aria-expanded') === 'true';


      /*
       * CLOSE
       */
      if (isOpen) {

        trigger.setAttribute(
          'aria-expanded',
          'false'
        );

        trigger.classList.remove('is-open');

        content.classList.remove('is-open');

        const currentHeight =
          content.scrollHeight;

        content.style.height =
          currentHeight + 'px';

        /*
         * Force browser reflow
         */
        content.offsetHeight;

        content.style.height = '0px';

      }


      /*
       * OPEN
       */
      else {

        trigger.setAttribute(
          'aria-expanded',
          'true'
        );

        trigger.classList.add('is-open');

        content.classList.add('is-open');

        /*
         * First get exact content height
         */
        content.style.height = '0px';

        const targetHeight =
          content.scrollHeight;

        /*
         * Animate to actual height
         */
        requestAnimationFrame(function () {
          content.style.height =
            targetHeight + 'px';
        });

        /*
         * After animation,
         * change to auto so dynamic content works
         */
        const onTransitionEnd =
          function (e) {

            if (e.propertyName !== 'height') {
              return;
            }

            if (
              trigger.getAttribute(
                'aria-expanded'
              ) === 'true'
            ) {
              content.style.height = 'auto';
            }

            content.removeEventListener(
              'transitionend',
              onTransitionEnd
            );
          };

        content.addEventListener(
          'transitionend',
          onTransitionEnd
        );
      }

    },
    true
  );


  /*
   * INITIALIZE
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initFAQ
    );
  } else {
    initFAQ();
  }


  /*
   * Shopify Theme Editor support
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        event.target &&
        event.target.querySelector &&
        event.target.querySelector('#faqsection')
      ) {
        initFAQ();
      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
